/**
 * Image Loader - Fade-in effect for images on load
 * 
 * Usage:
 * 1. Include script: <script src="{{ 'image-loader.js' | asset_url }}" defer></script>
 * 2. Add class to images: <img src="..." class="image-lazy" />
 * 
 * Images will fade in smoothly when they finish loading.
 */
(function() {
  'use strict';

  function injectStyles() {
    if (document.getElementById('image-loader-styles')) return;
    
    const style = document.createElement('style');
    style.id = 'image-loader-styles';
    style.textContent = `
      .image-lazy {
        opacity: 0;
        transition: opacity var(--duration-long, 500ms) ease;
      }
      
      .image-lazy.image-loaded {
        opacity: 1;
      }
    `;
    document.head.appendChild(style);
  }

  function initImageLoader() {
    const images = document.querySelectorAll('.image-lazy');
    
    images.forEach(img => {
      if (img.complete) {
        img.classList.add('image-loaded');
      } else {
        img.addEventListener('load', function() {
          img.classList.add('image-loaded');
        }, { once: true });
      }
    });
  }

  injectStyles();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initImageLoader);
  } else {
    initImageLoader();
  }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function() {
      injectStyles();
      initImageLoader();
    });
  }
})();
